import DeviceCard from "./DeviceCard";
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import OTPIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/otp_icon.png'
import MasterPinIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/otp.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Lottie from "lottie-react";
import areYouSure from '../../../../assets/animations/areYouSure.json'
import masterPinAnim from '../../../../assets/animations/masterPin.json'
import loadingAnim from '../../../../assets/animations/newLoading.json'
import { useEffect, useState } from "react";
import { GenerateLockOTPAPI, getPadlockPincodes, removeLockAPI } from "../../../../Api Methods/Api";
import { useDispatch } from "react-redux";
import PasscodeContentLayout from "../Automations/VirutalSources/SmartLocks/PasscodeContentLayout";
import GenerateLockOnTimePassCodeForm from "../Automations/EditAutomations/GenerateLockOnTimePassCodeForm";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import battery100 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_100.png'


const IglooCard = ({device, pinObject, showSuccess, apiData, siteUUID, refreshDevices, iglooLocks}) => {
    console.log(device);

    const [showConfirm, setShowConfirm] = useState(false)
    const [showMasterPin, setShowMasterPin] = useState(false)
    const [showPasscodes, setShowPasscodes] = useState(false)
    const [showLoading, setShowLoading] = useState(false)

    const [passcodes, setPasscodes] = useState([])
    const [showCreatePasscode, setShowCreatePasscode] = useState(false)
    const [showCreatedPasscode, setShowCreatedPasscode] = useState(false)
    const [OTPCode, setOTPCode] = useState("")
    
    const [modalPageIndex, setModalPageIndex] = useState(null);

    const dispatch = useDispatch();

    const GenerateOTP = async (otpName, startDate, endDate, type) => {
        const body = {
            lockID: device.lockID,
            startDate: startDate,
            endDate: endDate,
            type: type,
            uuid: siteUUID,
            otpName: otpName,
        }

        const responseData = await GenerateLockOTPAPI(apiData, body, dispatch)
        if (responseData && responseData.success) {
            setOTPCode(responseData.data.pin);
            setModalPageIndex(2)
            setShowCreatePasscode(false)
        } else {
            
            setOTPCode(responseData.msg);
            setModalPageIndex(2)
        }
    }

    const unlink = async () => {
        setShowConfirm(false)


        const responseData = await removeLockAPI(apiData, siteUUID, pinObject[0].Pin, dispatch)
        if (responseData.success) {
            showSuccess(true)
            window.location.reload();
        }
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 1:
                setShowCreatePasscode(true)
                break;
            case 2:
                setShowCreatedPasscode(true)
                break;
        }

    }, [modalPageIndex])

    const batteryColours = (batteryLevel) => {
        let colour = "";
        if (batteryLevel >= 0 && batteryLevel < 5) {
            // red
            colour = "rgb(220,114,119)"
        } else if (batteryLevel >= 5 && batteryLevel < 15) {
            //orange
            colour = "rgb(248,183,131)"
        } else {
            //green
            colour = "rgb(101,151,100)"
        }

        return colour;
    }

    const GetPasscodes = async () => {
        setShowLoading(true)

        const response = await getPadlockPincodes(apiData, device.lockID, dispatch)
        if (response.sucess){
            setPasscodes(response.data)
            setShowLoading(false)
            setShowPasscodes(true)
        } else {
            setShowLoading(false)
            //show error
        }
               
    }

    return (
        <>
        <Dialog
            header="Generate passcode"
            visible={showCreatePasscode}
            style={{ width: "40vw" }}
            onHide={() => setShowCreatePasscode(false)}
        >
            <GenerateLockOnTimePassCodeForm SmartLock={iglooLocks} GenerateOTP={GenerateOTP} />
        </Dialog>

        <Dialog
            header="Passcodes"
            visible={showPasscodes}
            style={{ width: "35vw" }}
            onHide={() => setShowPasscodes(false)}
        >
            <div style={{
                maxHeight: "70vh", 
                overflowY: "auto",
                alignItems:"center",
                display:"flex",
                flexDirection:"column",
                padding: "10px"}}>

                <Button label="Show master PIN" severity="danger" rounded onClick={()=> setShowMasterPin(true)}/>
                <br/>
                {passcodes.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <h3>No passcodes created</h3>
                    </div>
                ) : (
                    passcodes.map((passcode, index) => (
                        <div key={index}>
                            <PasscodeContentLayout passcodeData={passcode} />
                        </div>
                    ))
                )}
            </div>

        </Dialog>

        <Dialog
            header="Please wait"
            visible={showLoading}
            style={{ width: "35vw" }}
            onHide={() => setShowLoading(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Getting passcodes...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, downloading passcodes</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                </div>
        </Dialog>

        <Dialog
            header="Are you sure?"
            visible={showConfirm}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirm(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this Smart lock?`}</h3>
                <p style={{ color: "#6e6e6eff" }}>{`This page will reload for changes to take effect`}</p>

                <br />
                <Button label="No cancel" icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                <br />
                <Button label="Yes, unlink" icon="pi pi-check" severity="danger" onClick={() => unlink()} />

            </div>
        </Dialog>

        <Dialog
            header="Master pin"
            visible={showMasterPin}
            style={{ width: "40vw" }}
            onHide={() => setShowMasterPin(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={masterPinAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff", fontWeight:600, fontSize:"25px" }}>{`${device.masterPin}`}</h3>
                <br />
                <br />
                <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => setShowMasterPin(false)} />
            </div>
        </Dialog>

        <Dialog
            header="Passcode created"
            visible={showCreatedPasscode}
            style={{ width: "40vw" }}
            onHide={() => setShowCreatedPasscode(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={masterPinAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff", fontWeight:600, fontSize:"25px" }}>{OTPCode}</h3>
                <br />
                <br />
                <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => setShowCreatedPasscode(false)} />
            </div>        
        </Dialog>
        
       
        <DeviceCard
            header={`Smart Lock`}
            meta={[ <Link
                        to={`/Dashboard/Padlocks/Lock/${device.lockID}`}
                    >
                        {device.lockID}
                    </Link>,
                    <p style={{marginTop:6, marginBottom:0, color: "#818181"}}>
                        Last updated: {device.batteryReadAt ? format(new Date(device.batteryReadAt), "MMM do, yyyy") : "Unknown"}
                    </p>]}
            rightContent={
                <>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end"
                    }}>
                        <h3 style={{color:"var(--Primary-Color)", marginBottom:"0px"}}>{pinObject[0].pinName}</h3>
                        
                        <div style={{
                            marginTop:"0px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            gap:"1px"
                        }}>
                            <div style={{ position: "relative", width: 45, height: 45 }}>
                                <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>{device.battery !== 0 ? `${device.battery}%` : "?"}</p>
                                <div style={{
                                    width: 45,
                                    height: 45,
                                    backgroundColor: batteryColours(device.battery),
                                    WebkitMaskImage: `url(${battery100})`,
                                    WebkitMaskSize: "contain",
                                    WebkitMaskRepeat: "no-repeat",
                                    WebkitMaskPosition: "center",
                                    maskImage: `url(${battery100})`,
                                    maskSize: "contain",
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center",
                                }} />
                            </div>
                        </div>
                        
                        <div style={{
                            marginTop:"5px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            gap:"5px"
                        }}>
                            <img style={{width:"25px", cursor:"pointer"}} title="View created passcodes" src={OTPIcon} onClick={() => GetPasscodes()}/>
                            <img style={{width:"25px", cursor:"pointer"}} title="Create passcode" src={MasterPinIcon} onClick={() => setModalPageIndex(1)}/>
                            <img style={{width:"25px", cursor:"pointer"}} title="Unlink smartlock" src={removeIcon} onClick={() => setShowConfirm(true)}/>
                        </div>
                    </div>
                </>
            } 
        />

    </>
    );
}

export default IglooCard;